import svg4everybody from 'svg4everybody'
import isMobile from 'ismobilejs'
import 'regenerator-runtime/runtime'

import './styles'

import {
  cssAnimationObserver,
  headerChangeOnScroll,
  initStaggerList,
  menuTrigger,
  preloaderAnimation,
  toggleHtmlClassOnClick,
  uncheckOnClickOutside,
  mapPointHover,
  initHeadroom,
  initSaleProcessPage,
} from './scripts'
import { cssAnimationAttr, footer, header, menu } from './scripts/_constants'
import onPageLoad from './scripts/onPageLoad'
import form from './form'
import initQuarterHorizonsBanner from './scripts/initQuarterHorizonsBanner'
import initLoadOnScroll from './scripts/initLoadOnScroll'
import translate from './scripts/translate'

const hasSeenPreloader =
  Boolean(localStorage.getItem('hasSeenPreloader')) || false

const afterPreloader = new Promise(resolve => {
  if (hasSeenPreloader) {
    resolve()
  } else {
    window.addEventListener('preloaderEnd', resolve)
  }
})

// initialize things like header, footer
const oneTimeThings = () => {
  document.documentElement.classList.add(
    isMobile(window.navigator).any ? 'mobile' : 'desktop'
  )
  svg4everybody()
  menuTrigger()
  initHeadroom()
  initStaggerList(header)
  initStaggerList(menu)
  toggleHtmlClassOnClick(header)
  preloaderAnimation(hasSeenPreloader)
  headerChangeOnScroll()
  uncheckOnClickOutside(header)
  mapPointHover()
  initSaleProcessPage()
  if (document.querySelector('#load-on-scroll-wrapper')) {
    initLoadOnScroll()
  }

  document.body.classList.remove('disable-transition')

  afterPreloader.then(() => {
    Array.from(header.querySelectorAll(cssAnimationAttr))
      .concat(Array.from(footer.querySelectorAll(cssAnimationAttr)))
      .forEach(el => cssAnimationObserver.observe(el))

    if (document.querySelector('[class^="qh-banner"]')) {
      initQuarterHorizonsBanner()
    }
  })

  header.querySelectorAll('[data-remove-overflow]').forEach(el => {
    el.childNodes.forEach(child =>
      child.addEventListener(
        'transitionend',
        () => (el.style.overflow = 'initial'),
        {
          once: true,
        }
      )
    )
  })
  form(footer)
  translate()
}

document.addEventListener('DOMContentLoaded', () => {
  oneTimeThings()

  const container = document.querySelector('[data-barba="container"]')
  onPageLoad(container)
})
